import React from "react";
import LineChartBase from "components/charts/LineChartBase";
import HeaderComponent from "components/card/HeaderComponent";

const data = [
    { month: "May", score: 0 },
    { month: "Jun", score: 0 },
    { month: "Jul", score: 0 },
    { month: "Aug", score: 0 },
    { month: "Sep", score: 0 },
    { month: "Oct", score: 0 },
];

const PerformanceTrend = () => {
    return (
            <HeaderComponent
                title="Performance Trend"
                description="Monthly performance scores"
            >
                <LineChartBase 
                    data={data} 
                    xKey="month" 
                    yKey="score" 
                />
            </HeaderComponent>
    );
};

export default PerformanceTrend;
